var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruitApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 6.88196C10.5161 6.9209 10.0306 6.8334 9.59088 6.62804C3.40613 2.97696 2.27405 9.22037 2.89921 13.0695C3.59955 17.3503 5.41455 20.961 7.91705 21.2947C8.16641 21.3191 8.41731 21.2674 8.63663 21.1462L10.393 20.2525C10.5796 20.1567 10.7864 20.1067 10.9961 20.1067C11.2059 20.1067 11.4127 20.1567 11.5993 20.2525L13.3556 21.1462C13.5749 21.2674 13.8259 21.3191 14.0752 21.2947C16.5777 20.961 18.3927 17.353 19.093 13.0695C19.4331 10.9987 19.2635 8.23587 18.071 6.69037",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.003 4.20144C16.3519 4.81786 15.5373 5.23406 14.6563 5.40044C14.506 5.45021 14.3447 5.45685 14.1908 5.41959C14.0369 5.38233 13.8965 5.30266 13.7856 5.18964C13.6747 5.07662 13.5976 4.93477 13.5633 4.78018C13.5289 4.6256 13.5386 4.46448 13.5912 4.3151C13.7508 3.42336 14.1587 2.59474 14.7682 1.92444C15.4187 1.30708 16.2335 0.890459 17.1148 0.72452C17.2651 0.675121 17.4263 0.668759 17.58 0.706154C17.7337 0.743549 17.8739 0.823209 17.9847 0.936127C18.0956 1.04904 18.1726 1.19072 18.2071 1.34512C18.2416 1.49952 18.2322 1.6605 18.18 1.80985C18.02 2.70175 17.6121 3.53057 17.003 4.20144Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 3.44482V6.88232",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruitApple);
export default __webpack_public_path__ + "static/media/FruitApple.7e9de46997f9c5fddcf77e04d222ab08.svg";
export { ForwardRef as ReactComponent };